import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'solicitantes',
  getAllParams: ({ name, page, perPage }) => ({
    'filter[nombre]': name,
    page,
    per_page: perPage,
  }),
});
